module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$hydrowareSecurityJS.canView_P('chemicalrecord') == false) ? _c('div', [_c('hydroware-access-to-page-denied', {
    attrs: {
      "text": "Readings and Tasks"
    }
  })], 1) : _c('div', {
    staticClass: "x_panel"
  }, [_c('ChemicalRecord')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-176a0fba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ChemicalRecord/ChemicalRecord.vue
// module id = 774
// module chunks = 1